import React from 'react';
import { Route, IndexRoute } from 'react-router';
import CopaSarauDashboard from './CopaSarauDashboard';

export default (
  <Route path="copa-sarau">
    <IndexRoute component={(props) => <CopaSarauDashboard {...props} />} />
  </Route>
);
